import { UserPermissions } from "../models/UserPermissions";
import { useAdminSelector } from "../../../stores/AdminStore";

export const useHasAnyPermission = (permissions: UserPermissions | UserPermissions[]) => {
  const userPermissions = useAdminSelector(s => s.auth.permissions);

  const allPermissions = userPermissions
    ?.map(b => b.locations)
    .reduce((a, b) => a?.concat(b ?? []), [])
    ?.map(l => l.permissions)
    .reduce((a, b) => a?.concat(b ?? []), []) ?? [];

  return Array.isArray(permissions)
    ? permissions.some(p => allPermissions.includes(p))
    : allPermissions.includes(permissions);
};
